import { ErrorHandler, inject, Injectable } from '@angular/core';
import { ToastMessageService } from '@k12/app-services';
import { ToastMessageType } from '@k12/models';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler{
  private readonly toastMessageService: ToastMessageService = inject(ToastMessageService);

  handleError(error): void {
    this.toastMessageService.showToast(ToastMessageType.Error, error.message || 'An unexpected error occurred');
  }
}
